import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ConfirmationService, LazyLoadEvent, SelectItem } from 'primeng/api';
import { PagedResultGeneric, DatagridService, TranslationService, NotificationService } from 'src/app/shared';
import { timeoutWrapper } from 'src/app/shared/decorator/timeout-wrapper';
import { Contact } from '../../shared/contact.model';
import { ContactSearchDto } from '../../shared/contact-search.dto';
import { ContactService } from '../../shared/contact.service';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';

@Component({
  selector: 'wl-contact-record-search-grid',
  templateUrl: './contact-record-search-grid.component.html',
  styleUrls: ['./contact-record-search-grid.component.less'],
    standalone: false
})
export class ContactRecordSearchGridComponent extends LazySelectableTableComponent<ContactSearchDto, Contact> implements OnInit {
  @Output() completedSearch = new EventEmitter<PagedResultGeneric<Contact>>();

  constructor(datagridService: DatagridService, private _contactService: ContactService) {
    super('ContactId', datagridService);
  }

  ngOnInit(): void {
    this.preventInitialLoad = true;
  }

  searchFromSearchParamsComponent() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  fetchResults() {
    let searchResult = this._contactService.searchPost(this.searchParams);
    searchResult.then((result) => this.completedSearch.emit(result));
    return searchResult;
  }

  clearSearchResults() {
    this.searchResult = {} as PagedResultGeneric<Contact>;
    this.completedSearch.emit(this.searchResult);
  }
}
